const comments = [
  {
    name: '吃瓜一线网友',
    time: '2小时前',
    avatar: '🍉',
    content: '这个瓜我追了三天了，每天都有新进展，比追剧还刺激！编辑部辛苦了，整理得很清楚，给力！',
    likes: '2.3k',
  },
  {
    name: '八卦小能手',
    time: '3小时前',
    avatar: '🕵️',
    content: '终于有人把这些事情理清楚了，之前在微博看得一头雾水。这个平台真是吃瓜群众的福音，已经推荐给朋友了。',
    likes: '1.8k',
  },
  {
    name: '深夜吃瓜人',
    time: '5小时前',
    avatar: '🌙',
    content: '有时候觉得娱乐圈比电视剧精彩多了，现实永远比剧本魔幻。每天睡前必刷在线吃瓜，已经成为习惯了。',
    likes: '1.2k',
  },
  {
    name: '理性吃瓜群众',
    time: '8小时前',
    avatar: '🤔',
    content: '作为老粉想说，吃瓜归吃瓜，还是要理性看待。有些消息未经证实就被放大，希望大家也能有自己的判断。不过这个平台做得确实专业，分类清晰，更新及时。',
    likes: '967',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-20">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            瓜友热评
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            百万瓜友的真实声音，每条评论都代表一个吃瓜态度
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl mx-auto">
          {comments.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-2xl border border-background-200/60 p-5 hover:border-primary-200/60 transition-all duration-300"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center text-lg">
                  {item.avatar}
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{item.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}